import {
	ADD_DB_SUCCESS,
	ADD_DB_FAIL,
	GET_DB_SUCCESS,
	GET_DB_FAIL,
	GET_DBS_SUCCESS,
	GET_DBS_FAIL,
	UPDATE_DB_SUCCESS,
	UPDATE_DB_FAIL,
	DELETE_DB_SUCCESS,
	DELETE_DB_FAIL,
	SET_DB_LOADING,
	CLEAR_DB_ERROR,
} from '../reducers/types';
import axios from 'axios';

import { returnError, tokenConfig } from './actionHelperFunc';
const dbUrl = '/api/database';

// USER RELATED ACTIONS
export const addDatabase = (newDb) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_DB_ERROR });
		dispatch({ type: SET_DB_LOADING });

		const { data } = await axios.post(
			`${dbUrl}/addDbEdit`,
			newDb,
			tokenConfig(getState)
		);

		dispatch({
			type: ADD_DB_SUCCESS,
			payload: data.data,
		});
	} catch (error) {
		dispatch({ type: ADD_DB_FAIL, payload: returnError(error) });
	}
};

export const getDatabaseById = (dbEditId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_DB_ERROR });
		dispatch({ type: SET_DB_LOADING });

		const { data } = await axios.get(
			`${dbUrl}/getById?dbEditId=${dbEditId}`,
			tokenConfig(getState)
		);
		dispatch({
			type: GET_DB_SUCCESS,
			payload: data.data,
		});
	} catch (error) {
		dispatch({ type: GET_DB_FAIL, payload: returnError(error) });
	}
};

export const getDatabaseByProjectId =
	(projectObj) => async (dispatch, getState) => {
		try {
			dispatch({ type: CLEAR_DB_ERROR });
			dispatch({ type: SET_DB_LOADING });

			const { data } = await axios.post(
				`${dbUrl}/getByProjectId`,
				projectObj,
				tokenConfig(getState)
			);
			dispatch({
				type: GET_DB_SUCCESS,
				payload: data.data,
			});
		} catch (error) {
			dispatch({ type: GET_DB_FAIL, payload: returnError(error) });
		}
	};

export const getAllDatabasesByProject =
	(projectId) => async (dispatch, getState) => {
		try {
			dispatch({ type: CLEAR_DB_ERROR });
			dispatch({ type: SET_DB_LOADING });

			const { data } = await axios.get(
				`${dbUrl}/dbDashboard?projectId=${projectId}`,
				tokenConfig(getState)
			);

			dispatch({
				type: GET_DBS_SUCCESS,
				payload: data.data,
			});
		} catch (error) {
			dispatch({ type: GET_DBS_FAIL, payload: returnError(error) });
		}
	};

export const updateDatabase = (db) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_DB_ERROR });
		dispatch({ type: SET_DB_LOADING });

		const config = tokenConfig(getState);

		const { data } = await axios.post(`${dbUrl}/editDbEdit`, db, config);
		dispatch({ type: UPDATE_DB_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: UPDATE_DB_FAIL, payload: returnError(error) });
	}
};

export const deleteDatabase = (databaseId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_DB_ERROR });
		dispatch({ type: SET_DB_LOADING });

		const config = tokenConfig(getState);

		const { data } = await axios.delete(
			`${dbUrl}/delete/${databaseId}`,
			config
		);
		dispatch({ type: DELETE_DB_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: DELETE_DB_FAIL, payload: returnError(error) });
	}
};
